import _ from "lodash";

import { AvailablePopulateUsecase } from "../../usecases";
import { RemoveManyPointUsecase } from "../../usecases/remove-many-point.usecase";
import * as DateUtils from "../../utils/date/date";
import { SheetException } from "./DepartmentUploadExcel/DepartmentUploadExcel.exceptions";
import { ESocialImportService } from "./ESocialImport/ESocialImportService";
import { ESocialRemovePeriodsService } from "./ESocialRemovePeriods/ESocialRemovePeriodsService";

export class DepartmentPersonnelImportService {
    hasAvailableESocial = false;

    available = [];

    years = [];

    duplicatedCompanies = false;
    accountsPlans = [
        {
            label: "Pessoal via eSocial",
            subtitle: "Pessoal via eSocial",
            value: "eSocial",
            source: "eSocial",
            event: "eSocial",
            human: "eSocial",
            mainHuman: "pessoal",
            description:
                "Para importar os dados do Departamento Pessoal são aceitos dois formatos de arquivo: "
        },
        {
            label: "Pessoal",
            subtitle: "Pessoal",
            value: "personnel",
            source: "personnel",
            event: "Pessoal",
            human: "pessoal",
            mainHuman: "pessoal",
            description:
                "Para importar os dados do Departamento Pessoal são aceitos dois formatos de arquivo: "
        }
    ];

    current = {
        year: new Date().getUTCFullYear(),
        monthsImporting: [],
        pointsToSave: [],
        fileName: "",
        filesImporting: []
    };

    constructor({
        AvailableHttpGateway,
        Events,
        DepartmentUploadExcel,
        SerieHttpGateway,
        PointHttpGateway,
        PopulateManager,
        InsightHttpGateway,
        CompanyHttpGateway,
        DashboardAvailableHttpGateway,
        DepartmentTaxAndPersonnel,
        DepartamentDonwnloadExcel,
        ESocialHttpGateway,
        CalculatingMachineV2Gateway
    }) {
        this.AvailableHttpGateway = AvailableHttpGateway;
        this.Events = Events;
        this.DepartmentUploadExcel = DepartmentUploadExcel;
        this.SerieHttpGateway = SerieHttpGateway;
        this.PointHttpGateway = PointHttpGateway;
        this.PopulateManager = PopulateManager;
        this.InsightHttpGateway = InsightHttpGateway;
        this.CompanyHttpGateway = CompanyHttpGateway;
        this.DashboardAvailableHttpGateway = DashboardAvailableHttpGateway;
        this.DepartmentTaxAndPersonnel = DepartmentTaxAndPersonnel;
        this.DepartamentDonwnloadExcel = DepartamentDonwnloadExcel;
        this.ESocialHttpGateway = ESocialHttpGateway;
        this.CalculatingMachineV2Gateway = CalculatingMachineV2Gateway;
    }

    init({ company, accounting, stateParamsYear, stateParamsAccountPlan }) {
        this.Events.setParamns({ companyId: company.props._id });

        this.setHasAvailableESocial({ company });

        this.initAccountPlanCurrent(stateParamsAccountPlan);

        this._setAvailable({ company });

        this._setCurrentDate({ company, stateParamsYear });
    }

    setHasAvailableESocial({ company }) {
        const available = this.AvailableHttpGateway.get({
            companyId: company.props._id,
            scenarioId: "ORIGINAL",
            source: "eSocial"
        });

        if (_.get(available, "length"))
            return (this.hasAvailableESocial = true);

        return (this.hasAvailableESocial = false);
    }

    initAccountPlanCurrent(stateParamsAccountPlan) {
        if (this.hasAvailableESocial) {
            const accountPlan = this.accountsPlans.find(
                (a) => a.source === stateParamsAccountPlan
            );

            this.accountPlanCurrent = accountPlan || this.accountsPlans[0];
        } else this.accountPlanCurrent = this.accountsPlans[1];
    }

    setAccountPlanCurrent({ value } = {}) {
        if (!value) return false;

        const accountPlan = this.accountsPlans.find((a) => a.value === value);

        if (!accountPlan) return false;

        this.accountPlanCurrent = accountPlan;
    }

    _setAvailable({ company } = {}) {
        this.available = this.AvailableHttpGateway.get({
            companyId: company.props._id,
            scenarioId: "ORIGINAL",
            source: this.accountPlanCurrent.source
        });
    }

    _setCurrentDate({ company, stateParamsYear } = {}) {
        const years = this.AvailableHttpGateway.getYears(
            company.props._id,
            this.accountPlanCurrent.source,
            "ORIGINAL"
        );

        let year;
        let _stateParamsYear = Number(stateParamsYear);

        if (years.includes(_stateParamsYear)) year = _stateParamsYear;
        else {
            if (this.available.length) {
                const lastDate = _.last(this.available);
                year = new Date(lastDate).getFullYear();
            } else year = new Date().getFullYear();
        }

        this.years = DateUtils.years(2010, new Date().getUTCFullYear());

        this.current.year = year;
    }

    setAccountPlanCurrentData({ source, company }) {
        this.setAccountPlanCurrent({ value: source });

        this._setAvailable({ company });
    }

    setFileName(name) {
        this.current.fileName = name;
    }

    validateImport({ companyImportModel, sourceImport, yearImport }) {
        // Company
        if (!companyImportModel) {
            // empresa não encontrada
            throw new SheetException(
                "Não foi possível importar os dados pois a planilha não pertence a essa empresa."
            );
        }
        companyImportModel.validate();

        if (!sourceImport)
            // Source
            throw new SheetException(
                "Fonte de Dados não informado na importação."
            );
        if (companyImportModel.source !== sourceImport)
            throw new SheetException(
                "Não foi possível importar os dados pois a planilha não pertence a Fonte de Dados selecionada."
            );

        // Year
        if (companyImportModel.year != yearImport)
            throw new SheetException(
                "Não foi possível importar os dados pois a planilha não pertence ao ano selecionado."
            );
    }

    async getPointsToSave(serieIdsSheet, pointsSheet, company) {
        const pointsToSave = [];

        const series = await this.SerieHttpGateway.getByIds({
            serieIds: serieIdsSheet,
            companyIds: [company.props._id]
        });

        //this.series = series;

        pointsSheet.forEach((point) => {
            const serie = series.find((s) => s._id === point.serieId);

            if (serie.type === "raw") {
                const month = String(point.month + 1).padStart(2, 0);

                const time = new Date(`${this.current.year}-${month}-01`);

                pointsToSave.push({
                    companyId: point.companyId,
                    serieId: point.serieId,
                    measures: { f: point.value },
                    sources: [this.accountPlanCurrent.source],
                    time
                });
            }
        });

        return pointsToSave;
    }

    getMonthsImporting(pointsSheet) {
        const months = [];

        pointsSheet.forEach((point) => {
            if (point.value && !months.includes(point.month))
                months.push(point.month);
        });

        if (!months.length)
            throw new SheetException(
                "Não foi possível importar os dados pois a planilha está com os dados zerados."
            );

        return months.map((month) => {
            return {
                fileName: "",
                month: DateUtils.months(month),
                actions: { remove: false, success: false, loading: true }
            };
        });
    }

    async _setDataToImport({ company, sheets }) {
        try {
            const companyImportModel = sheets.find(
                (sheet) => sheet.companyId === company.props._id
            );

            this.validateImport({
                companyImportModel,
                sourceImport: this.accountPlanCurrent.source,
                yearImport: this.current.year
            });

            const serieIdsSheet = companyImportModel.serieIds;
            const pointsSheet = companyImportModel.points;

            this.current.pointsToSave = await this.getPointsToSave(
                serieIdsSheet,
                pointsSheet,
                company
            );

            this.current.monthsImporting = this.getMonthsImporting(pointsSheet);

            return true;
        } catch (error) {
            this.Events.send(`${this.accountPlanCurrent.event}.importar.error`);

            return { error };
        }
    }

    async analysisDefault({ files, company }) {
        try {
            const sheets = await this.DepartmentUploadExcel.exec({
                files
            });

            return await this._setDataToImport({ company, sheets });
        } catch (error) {
            return { error };
        }
    }

    async afterSaveESocial({ company }) {
        const availablePopulateUsecase = new AvailablePopulateUsecase();
        await availablePopulateUsecase.execute({
            companyId: company.props._id
        });

        this._setAvailable({ company });

        this.current.monthsImporting = [];

        this._triggerInsights(company);
    }

    async importDataESocial({
        company = null,
        accounting,
        user,
        isCreateCompany = false
    }) {
        const eSocialImportService = new ESocialImportService({
            ESocialHttpGateway: this.ESocialHttpGateway,
            Company: this.CompanyHttpGateway
        });

        const response = await eSocialImportService.exec({
            files: this.current.filesImporting,
            company,
            accounting,
            user,
            isCreateCompany
        });

        this.duplicatedCompanies =
            eSocialImportService.hasDuplicateImportCompanies();

        if (
            _.get(response, "name") === "Error" ||
            _.get(response, "eSocialIsNotValid")
        ) {
            this.current.monthsImporting = [];
            return response;
        }

        if (!isCreateCompany) await this.afterSaveESocial({ company });

        return response;
    }

    hasCompaniesDuplicatedUpload() {
        if (this.duplicatedCompanies) {
            this.duplicatedCompanies = false;
            return true;
        } else return false;
    }

    async analysisESocial({ files }) {
        this.current.monthsImporting = [];
        this.current.filesImporting = files;

        return new Promise((resolve, reject) => {
            for (const file of files) {
                this.current.monthsImporting.push({
                    fileName: file.name,
                    actions: { remove: false, success: false, loading: true }
                });
            }

            setTimeout(() => {
                for (const file of this.current.monthsImporting) {
                    file.actions.loading = false;
                    file.actions.success = true;
                }

                resolve(true);
            }, 5000);
        });
    }

    typeOfImport(files) {
        if (!files) return "";

        const type = _.get(files, "[0].type");

        if (
            type &&
            (type === "text/xml" ||
                type === "application/zip" ||
                type.indexOf("zip") > -1)
        )
            return "eSocial";

        return "personnel";
    }

    _updateAvailable(points, company) {
        const newDates = [];
        points.forEach((point) => {
            if (newDates.indexOf(point.time.toISOString()) == -1) {
                if (point.measures.f) newDates.push(point.time.toISOString());
            }
        });

        if (newDates.length) {
            this.AvailableHttpGateway.saveAndPopulate({
                source: this.accountPlanCurrent.source,
                newDates,
                companyId: company.props._id,
                override: true
            });
        }
    }

    async _updatePoints(points, company) {
        const managerPoints = this.PopulateManager.findOneCollection({
            collections: "points"
        });

        if (managerPoints) {
            // Atualizar manager points
            const mergeForSelects = [];

            mergeForSelects.push(
                `ORIGINAL.${this.source}.${this.current.year}`
            );

            const keys = _.get(managerPoints, "keys") || [];
            this.PopulateManager.modify(
                { collections: "points" },
                {
                    $set: {
                        keys: _.uniq([...mergeForSelects, ...keys]),
                        keysBefore: [...keys]
                    }
                }
            );
        } else {
            await this.CalculatingMachineV2Gateway.calculateSeries({
                companyData: company.props,
                source: "personnel",
                years: [this.current.year]
            });
        }
    }

    _afterSave(points, company) {
        this._updateAvailable(points, company);
        this._updatePoints(points, company);
    }

    async _savePoints(points, company) {
        await this.PointHttpGateway.saveMany({
            accountingId: company.props.accountingId,
            companyId: company.props._id,
            source: this.accountPlanCurrent.source,
            scenarioId: "ORIGINAL",
            points
        });
        this._afterSave(points, company);
    }

    async _triggerInsights(company) {
        const data = {
            company: {
                _id: company.props._id,
                name: company.props.name,
                accounting: {
                    ...company.props.accounting
                },
                accountingId: company.props.accountingId
            },
            period: "monthly",
            sources: [this.accountPlanCurrent.source],
            scenarioIds: ["ORIGINAL"]
        };
    }

    async onSave({ company }) {
        try {
            await this._savePoints(this.current.pointsToSave, company);

            this._setAvailable({ company });

            this.current.monthsImporting = [];

            this._triggerInsights(company);

            return true;
        } catch (error) {
            console.error(error);
            return { error };
        }
    }

    async generateDepartmentSeries({
        source = this.accountPlanCurrent.source,
        accounting,
        company
    }) {
        const response = await this.SerieHttpGateway.importDataDepartments({
            companyId: company.props._id,
            accounting: {
                _id: accounting.props._id,
                name: accounting.props.name
            }
        });

        await this.DashboardAvailableHttpGateway.populate({
            companyId: this.companyData._id
        });
    }

    async onExportToExcel({ company, accounting }) {
        const result = [];
        const hasSeries = await this.SerieHttpGateway.populateDepartament({
            companyId: company.props._id,
            source: "personnel"
        });
        if (!hasSeries) {
            await this.generateDepartmentSeries({ accounting, company });
            await this.Serie.populateDepartament({
                companyId: company.props.props._id,
                source: "personnel"
            });
        }
        await this.CalculatingMachineV2Gateway.calculateSeries({
            companyData: company.props,
            source: "personnel"
        });
        this.DepartmentTaxAndPersonnel.setSource("personnel");
        const response =
            this.DepartmentTaxAndPersonnel.getSeriesAndPointsCalculated({
                companyId: company.props._id
            });
        company.props.nameFixed = company.props.name.replace(
            /[^0-9a-zA-Z]+/gi,
            ""
        );
        result.push({
            details: company.props,
            series: response.series,
            points: response.points
        });
        await this.DepartamentDonwnloadExcel.export({
            data: result,
            source: "pessoal",
            accounting: accounting.props,
            year: this.current.year
        });
        this.Events.send(`${this.accountPlanCurrent.event}.baixar.modelo`);
    }

    pointsDelete(dates, company) {
        dates.forEach((date) => {
            const time = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1);
            this.PointHttpGateway.deleteMany({
                c: company.props._id,
                sc: "ORIGINAL",
                so: this.accountPlanCurrent.source,
                t: time
            });
        });
    }

    _afterRemove(dates, company) {
        this.pointsDelete(dates, company);
    }

    async removeAvailable({ year, month, newAvailable, company }) {
        this.AvailableHttpGateway.saveAndPopulate({
            companyId: company.props._id,
            source: this.accountPlanCurrent.source,
            newDates: newAvailable,
            scenarioId: "ORIGINAL",
            override: true,
            allAvailable: true
        });

        this._eSocialRemovePeriods({
            companyId: company.props._id,
            periods: [{ year, month }]
        });

        this._setAvailable({ company });

        const date = new Date(`${year}-${String(month).padStart(2, 0)}-01`);

        this._afterRemove([date], company);

        this.Events.send(`${this.accountPlanCurrent.human}.remove.planilha`);

        if (company.props._id) {
            const removeManyPointUsecase = new RemoveManyPointUsecase();
            await removeManyPointUsecase.execute({
                companyId: company.props._id,
                sources: [this.accountPlanCurrent.source],
                times: [date],
                all: false
            });
        }
    }

    async _eSocialRemovePeriods({ companyId, periods } = {}) {
        if (this.accountPlanCurrent.source != "eSocial") return false;

        const eSocialRemovePeriodsService = new ESocialRemovePeriodsService();

        await eSocialRemovePeriodsService.exec({ companyId, periods });
    }

    async removeManyAvailable({ times, newAvailable, company }) {
        this.AvailableHttpGateway.saveAndPopulate({
            companyId: company.props._id,
            source: this.accountPlanCurrent.source,
            newDates: newAvailable,
            scenarioId: "ORIGINAL",
            override: true,
            allAvailable: true
        });

        this._setAvailable({ company });

        const periods = [];

        times = times.map((time) => {
            const timePartitioned = time.split("-");

            const date = new Date(
                `${timePartitioned[0]}-${String(timePartitioned[1]).padStart(
                    2,
                    0
                )}-01`
            );

            periods.push({
                year: date.getUTCFullYear(),
                month: date.getUTCMonth() + 1
            });

            return date;
        });

        this._eSocialRemovePeriods({ companyId: company.props._id, periods });

        this._afterRemove(times, company);

        this.Events.send(`${this.accountPlanCurrent.event}.remove.planilhas`);

        if (company.props._id) {
            const removeManyPointUsecase = new RemoveManyPointUsecase();
            await removeManyPointUsecase.execute({
                companyId: company.props._id,
                sources: [this.accountPlanCurrent.source],
                times: times,
                all: false
            });
        }
    }
}
